export const RESEND_COOLDOWN_SEC = 60;

export const OTP_LENGTH = 6;
